import * as actions from './actionTypes';

export const apiLoading = (msg?: string | null) => ({
	type: actions.API_LOADING,
	payload: msg
})

export const apiResSuccess = (msg?: string | null) => ({
	type: actions.API_SUCCESS,
	payload: msg
})

export const apiResError = (errMsg?: string | null) => ({
	type: actions.API_ERROR,
	payload: errMsg
})

export const apiResInfo = (msg?: string | null) => ({
	type: actions.API_INFO,
	payload: msg
}) 

export const preventApiCall = (msg?: string | null) => ({
	type: actions.API_ERROR,
	payload: msg
})

export const apiReset = () => ({
	type: actions.API_RESET
})